import React from "react";
import Seo from "./Seo";

/**
 * Wraps a route that must never be indexed.
 *
 * Emits `noindex, nofollow` plus a title/description from the route registry,
 * so auth and transactional pages still get a sensible browser tab and a
 * canonical URL while being explicitly excluded from search results.
 *
 * Title and description fall back to the registry entry for the current path,
 * which is where the `index: false` classification lives — so a route's
 * indexability is declared in exactly one place.
 */
export default function NoIndex({ children, title, description }) {
  return (
    <>
      <Seo index={false} title={title} description={description} />
      {children}
    </>
  );
}
